import { FC } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { fetchEspAccountsQueryWithWhatsApp } from 'api/queries/espAccounts';
import { SERVICE_PROVIDERS, WhatsAppEspAccount, WhatsAppSenderFields } from 'modules/graphql';
import { WhatsAppSenderContext } from './WhatsAppSenderContext';

export const WhatsAppSenderContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const {
    data: { espAccounts: espAccountsGraphql = [] } = {},
  } = useGraphql<{
    espAccounts: WhatsAppEspAccount[];
  }>(fetchEspAccountsQueryWithWhatsApp);
  const senders = espAccountsGraphql.reduce(
    (acc: WhatsAppSenderFields[], curr: WhatsAppEspAccount) => {
      if (curr.esp === SERVICE_PROVIDERS.INFOBIP && curr.senders) {
        return [...acc, ...curr.senders];
      }
      return acc;
    },
    [] as WhatsAppSenderFields[],
  );
  return (
    <WhatsAppSenderContext.Provider
      value={{
        senders,
      }}
    >
      {children}
    </WhatsAppSenderContext.Provider>
  );
};
